const maxFileSize = 1024 * 1024;
export const checkMaxSize = (file: File, size: number): boolean => file.size > (maxFileSize * size)
